import { blogPosts } from '../../../mocks/blogPosts';

export default function BlogSection() {
  const handleBlogClick = (slug: string) => {
    window.REACT_APP_NAVIGATE(`/blog/${slug}`);
  };

  return (
    <section className="py-20 bg-gradient-to-br from-teal-50 to-white" id="blog" aria-labelledby="blog-heading">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 id="blog-heading" className="text-4xl font-bold text-gray-900 mb-4">
            <strong>Latest Tax Guides & Insights</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Expert advice and comprehensive guides to help you navigate tax season with confidence
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <article 
              key={post.id}
              onClick={() => handleBlogClick(post.slug)}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="relative h-56 overflow-hidden">
                <img 
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-4 py-2 bg-teal-600 text-white rounded-full text-sm font-semibold whitespace-nowrap">
                    {post.category}
                  </span>
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-4 text-sm text-gray-500 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {post.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {post.readTime}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 hover:text-teal-600 transition-colors">
                  {post.title}
                </h3>
                <p className="text-gray-600 mb-4 line-clamp-2">
                  {post.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-teal-600 font-semibold text-sm">Read More →</span>
                  <div className="flex items-center gap-2 text-sm text-gray-500">
                    <i className="ri-user-line"></i>
                    {post.author}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}